module.exports = __webpack_public_path__ + "static/media/increment-arrow.8ab6e780.png";